import "./TheoOrbV8.css";

/**
 * Theo V8 — "Living Nebula in Glass".
 *
 * A luminous glass sphere with internal nebula clouds that drift in
 * coordinated organic motion. Every layer runs on a unique PRIME
 * duration (7s, 11s, 13s, 17s, 19s, 23s) so the composite pattern's
 * least common multiple is enormous — the loop has no visible seam,
 * no replay feeling, no mechanical rotation.
 *
 * Composition (back→front):
 *   ambient halo  · warm bottom rim · glass sphere [
 *     5 nebula blobs · luminous heart · 6 dust particles ·
 *     state-only wave/burst overlays
 *   ] · top glass specular · iridescent edge
 *
 * Colors:
 *   exterior — lavender glass
 *   core     — soft violet
 *   accents  — warm coral · soft amber/orange · pink/magenta streaks
 *
 * States:
 *   idle        — quietly alive: nebula drifts, heart pulses, dust floats
 *   thinking    — internal energy intensifies (faster prime cycles, brighter)
 *   responding  — gentle warm waves travel through the orb
 *   celebrating — single elegant bloom (no celebration, just acknowledgement)
 */
export function TheoOrb({ state = "idle", size = "lg", className = "" }) {
  return (
    <div
      className={`theo-nebula ${size} ${state} ${className}`}
      data-testid="theo-orb"
      data-state={state}
      aria-hidden="true"
    >
      <div className="n-halo" />
      <div className="n-rim" />

      <div className="n-sphere">
        {/* The nebula — 5 drifting colored clouds */}
        <span className="n-blob b-violet" />
        <span className="n-blob b-coral" />
        <span className="n-blob b-amber" />
        <span className="n-blob b-magenta" />
        <span className="n-blob b-pink" />

        {/* Warm coral + amber accent near the center (V8.1 polish) */}
        <span className="n-warm-core" />

        {/* Luminous heart — gives the orb a sense of consciousness */}
        <span className="n-heart" />

        {/* Bright dust particles — fifteen, each with unique prime duration */}
        <span className="n-dust d1" />
        <span className="n-dust d2" />
        <span className="n-dust d3" />
        <span className="n-dust d4" />
        <span className="n-dust d5" />
        <span className="n-dust d6" />
        <span className="n-dust d7" />
        <span className="n-dust d8" />
        <span className="n-dust d9" />
        <span className="n-dust d10" />
        <span className="n-dust d11" />
        <span className="n-dust d12" />
        <span className="n-dust d13" />
        <span className="n-dust d14" />
        <span className="n-dust d15" />

        {/* State overlays */}
        <span className="n-wave" />
        <span className="n-wave w2" />
        <span className="n-burst" />
      </div>

      <div className="n-specular" />
      <div className="n-specular-2" />
      <div className="n-edge" />
    </div>
  );
}

export default TheoOrb;
